import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-checkbox',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './checkbox.component.html', 
  styleUrl: './checkbox.component.scss'
})
export class CheckboxComponent implements OnInit, OnChanges {
  @Input() names: { id: string; name: string }[] = [];
  selectedValues: { [id: string]: boolean } = {};

  @Output() selectedItems = new EventEmitter<{ id: string; values: string  }>();
  @Input() existingValue: ({ key: string; value: string } | string)[] = [];
  @Input() keyRequired = false;
  @Input() checkValidation: boolean = false;
  @Output() requiredKey = new EventEmitter<{ id: string; required: boolean }>();
  @Input() disable:boolean = false
  showRequiredError: boolean = false;
  @Input() id: string = "";
ngOnChanges(changes: SimpleChanges) {
  if (changes['checkValidation'] && changes['checkValidation'].currentValue === true) {
    if (this.keyRequired) {
      const anySelected = Object.values(this.selectedValues).some(v => v === true);
      this.showRequiredError = !anySelected;
    }
  }
  if (changes['existingValue'] && changes['existingValue'].currentValue) {
    console.log(this.existingValue);
    
    this.initializeOptions(this.names);
  }

  // 👇 Handle async API update of names
  if (changes['names'] && changes['names'].currentValue) {
    this.initializeOptions(changes['names'].currentValue);
  }
}

private initializeOptions(names: { id: string; name: string }[]) {
  // normalize names
  this.names = (names as any)?.list ?? names ?? [];
  if (!Array.isArray(this.names)) this.names = [];

  // reset
  this.selectedValues = {};
  this.names.forEach(item => {
    this.selectedValues[item.id] = false;
  });

  // apply existing values
  if (this.existingValue?.length) {
    this.existingValue.forEach((val: any) => {
      // ✅ object format
      if (val?.key) {
        if (this.selectedValues.hasOwnProperty(val.key)) {
          this.selectedValues[val.key] = val.value === 'Y';
        }
      }
      // ✅ plain string fallback
      else if (typeof val === 'string' && this.selectedValues.hasOwnProperty(val)) {
        this.selectedValues[val] = true;
      }
    });
  }
}




ngOnInit() {
  console.log(this.existingValue);
  
  this.initializeOptions(this.names);

  if (this.keyRequired === true) {
    setTimeout(() => {
      this.requiredKey.emit({ id: this.id, required: this.keyRequired });
    }, 300);
  }
}




  onChange(option: { id: string; name: string }) {
    // clicked item real value
    const clickedVal: 'Y' | 'N' = this.selectedValues[option.id] ? 'Y' : 'N';

    // emit for EACH id: clicked -> clickedVal, others -> reflect their current selectedValues
    this.names.forEach(item => {
      const val: 'Y' | 'N' = item.id === option.id
        ? clickedVal
        : (this.selectedValues[item.id] ? 'Y' : 'N');
      this.selectedItems.emit({ id: item.id, values: val });
    });

    // validation UI (unchanged)
    if (this.keyRequired) {
      const anySelected = Object.values(this.selectedValues).some(v => v === true);
      this.showRequiredError = !anySelected;
    }
  }






}

